import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GivePrivacyConsentPublic = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  customerId: number;
};
/**
 * Gives the privacy consent.
 *
 * @returns void
 */
export function givePrivacyConsentPublic(
  { businessUnit, label, customerId }: GivePrivacyConsentPublic,
  requestConfig: ApiRequestConfig = {},
): Promise<void> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/customers/${customerId}/consent`,
      errors: { 400: 'If backend returns an error or input is invalid.', 404: 'Not Found' },
    },
    requestConfig,
  );
}
